<template>
    <div 
        v-if="visible" 
        class="supsis-context-menu"
        :style="menuStyle"
        @click.stop
    >
        <div 
            v-for="(item, index) in items" 
            :key="index"
            class="context-menu-item"
            :class="{ 'danger': item.danger, 'disabled': item.disabled, 'divider': item.divider }"
            @click="!item.disabled && !item.divider && onItemClick(item)"
        >
            <template v-if="!item.divider">
                <i v-if="item.icon" class="material-icons">{{ item.icon }}</i>
                <span>{{ item.label }}</span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContextMenu",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        items: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        menuStyle: function () {
            var style = {};
            var menuWidth = 200;
            var menuHeight = this.items.length * 40;
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            
            var left = this.x;
            var top = this.y;
            
            if (this.x + menuWidth > viewportWidth) {
                left = this.x - menuWidth;
            }
            
            if (this.y + menuHeight > viewportHeight) {
                top = viewportHeight - menuHeight - 10;
            }
            
            style.left = Math.max(10, left) + 'px';
            style.top = Math.max(10, top) + 'px';
            
            return style;
        }
    },
    methods: {
        onItemClick: function (item) {
            this.$emit('item-click', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.supsis-context-menu {
    position: fixed;
    z-index: 9999;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    padding: 4px 0;

    .context-menu-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 16px;
        cursor: pointer;
        transition: background 0.15s ease;
        font-size: 14px;
        color: #22272d;
        user-select: none;

        .material-icons {
            font-size: 18px;
            color: #6b7785;
            flex-shrink: 0;
        }

        &:hover {
            background: #f8f9fa;

            .material-icons {
                color: #22272d;
            }
        }

        &.danger {
            .material-icons {
                color: #d32f2f;
            }

            &:hover {
                background: #fff5f5;

                .material-icons {
                    color: #c62828;
                }

                span {
                    color: #d32f2f;
                }
            }
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;

            &:hover {
                background: transparent;
            }
        }

        &.divider {
            height: 1px;
            padding: 0;
            margin: 4px 8px;
            background: #e8e8e8;
            cursor: default;

            &:hover {
                background: #e8e8e8;
            }
        }
    }
}
</style>


